module.exports = __webpack_public_path__ + "media/certifications/certificates-501a9bd8.webp";